import { mergeWith } from "lodash-es";

export function mergeEmpty<T>(
  target: T,
  ...source: { [key: string]: unknown }[]
): T {
  return mergeWith(target, ...source, (oldVal: unknown, newVal: unknown) => {
    if (typeof oldVal === "boolean" || typeof oldVal === "number") {
      return oldVal;
    }

    return oldVal || newVal;
  });
}
